import React from "react";
import { Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import GeneratePayrollPresenter from "./GeneratePayrollPresenter";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import PayrollFormPage from "./payroll-form/PayrollFormPage";
import { DatePicker, Space } from "antd";
import InputFactory from "../../../components/InputFactory";
import Progress from "../../../components/Progress";

class GeneratePayrollPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new GeneratePayrollPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      selected: [],
      limit: 50,
      current: 1,
      description: null,
      name: null,
      payrollType: "",
      employmentType: "",
      additionalSelectValue: "",
      addendumType: "",
      count: 0,
      payrollListing: false,
      csvData: null,
      filename: "",
      allowance: [],
      employment: [],
      suspension: [],
      startDate: null,
      endDate: null,
      selectedEmployees: "",
      selectedEmployeeID: "",
      payrollCode: "",
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    try {
      const [type, empType, leaves, suspend] = await Promise.all([
        findObjectUseCase().execute("incentive"),
        findObjectUseCase().execute("employment_type"),
        findObjectUseCase().execute("leave_type"),
        findObjectUseCase().execute("suspension"),
      ]);

      const allowance = type.map((item) => item.allowanceType);

      const employment = empType;
      const leaveType = leaves.map((item) => item.name);
      const suspension = suspend;

      this.setState({ allowance, employment, leaveType, suspension });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    this.refetchData();
  }

  getCollectionName() {
    return "employees";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async handlePayrollTypeChange(field, value) {
    const combinations = await findObjectUseCase().execute(
      "payroll_combination",
      {
        keys: ["earnings"],
        where: {
          earnings: value,
        },
      }
    );

    let ids = [];

    for (const item of combinations) {
      ids.push(item.id);
    }

    console.log("value", value);

    if (value === "Augmentation Pay" || value === "Basic Pay") {
      return this.presenter.getPayrollTypeChange(field, value, ids);
    } else if (value === "J.O Salary") {
      const { employment } = this.state;

      const filtered = employment.filter((employmentType) => {
        return employmentType.name === "Job Order";
      });

      const type = filtered.map((employmentType) => ({
        label: employmentType.name,
        value: employmentType,
      }));

      const jobOrder = type[0]?.value;

      this.presenter.getChangeFilterType(
        "Pointer",
        jobOrder, // This is a string, not an object
        "employmentType"
      );

      this.setState({ [field]: value });
    } else if (value === "Individual Payroll" || value === "Special Payroll") {
      this.setState({ [field]: value });
    }
  }

  onChangeFilterType(type, value, field) {
    return this.presenter.getChangeFilterType(type, value, field);
  }

  filterSubmit(where, field) {
    return this.presenter.getfilterSubmit(where, field);
  }

  handleEmploymentTypeChange(field, value) {
    return this.presenter.getEmploymentTypeChange(field, value);
  }

  handleSelectedEmployees(value) {
    const employees = this.getSelectedEmployee(this.state.selectedEmployees);
    const selectedOption = employees.find((option) => option.value === value);

    return this.presenter.getSelectedEmployees(selectedOption);
  }

  async refetchData() {
    this.setState({
      payrollType: "",
      employmentType: "",
      additionalSelectValue: "",
      filename: "",
    });

    const objects = await this.presenter.getObjects();
    return objects;
  }

  handleFileUpload = (event) => {
    const { additionalSelectValue } = this.state;
    return this.presenter.getFileUpload(event);
  };

  parseCSV = (text) => {
    return this.presenter.getParseCSV(text);
  };

  handleGenerate = () => {
    return this.presenter.getHandleGenerate();
  };

  async onChange(dateString) {
    return this.presenter.getOnChange(dateString);
  }
  closePrint() {
    this.setState({ payrollListing: false });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { RangePicker } = DatePicker;
    const {
      objects,
      loading,
      payrollType,
      employmentType,
      csvData,
      additionalSelectValue,
      count,
      limit,
      current,
      employment,
      leaveType,
      suspension,
      startDate,
      endDate,
      selectedEmployees,
      selectedEmployeeID,
      addendumType,
      selected,
    } = this.state;

    const { payrollTypeLabel } = this.presenter;

    // const leaveList = leaveType.filter((item) => item.name);
    const formatDate = (date, label) =>
      date
        ? date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : `${label} Not Selected`;

    const start = formatDate(startDate, "Start Date");
    const end = formatDate(endDate, "End Date");

    if (!schema) return <Progress />;

    const isEligibleEmploymentType = (employmentType) =>
      employment.includes(employmentType);

    const shouldShowAdditionalSelect =
      [
        "General Payroll",
        "Addendum Payroll",
        "Special Payroll",
        "Individual Payroll",
      ].includes(payrollType) && isEligibleEmploymentType(employmentType);

    const shouldShowEmployees =
      ["Individual Payroll"].includes(payrollType) &&
      isEligibleEmploymentType(employmentType) &&
      additionalSelectValue;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "agency" &&
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "Nameextension" &&
        fields !== "position" &&
        fields !== "office" &&
        fields !== "division"
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>

              <div style={{ marginTop: "20px", width: "100%" }}>
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                  </div>

                  <div className="row">
                    <div className="col-sm-3 mt-1 ">
                      <SearchSelect
                        value={payrollType}
                        onChange={(value) =>
                          this.handlePayrollTypeChange("payrollType", value)
                        }
                        options={this.presenter.getPayrollLabel()}
                      />
                    </div>
                    {payrollType && payrollType !== "J.O Salary" && (
                      <div className="col-sm-3 mt-1">
                        <SearchSelect
                          value={employmentType}
                          onChange={(value) =>
                            this.handleEmploymentTypeChange(
                              "employmentType",
                              value
                            )
                          }
                          options={this.presenter.setEmploymentOptions()}
                        />
                      </div>
                    )}

                    {(employmentType || payrollType === "J.O Salary") && (
                      <div className="col-sm-3 mt-1">
                        <SearchSelect
                          value={additionalSelectValue}
                          onChange={(value) =>
                            this.presenter.getAdditionalSelectChange(value)
                          }
                          options={this.presenter.setAdditionalOptions()}
                        />
                      </div>
                    )}
                    {/* {payrollType === "Basic Pay" &&
                      additionalSelectValue === "Addendum Payroll" && (
                        <div className="col-sm-3 mt-1">
                          <SearchSelect
                            value={addendumType}
                            onChange={(value) =>
                              this.presenter.handleAddendumCategory(
                                "addendumType",
                                value
                              )
                            }
                            options={this.presenter.getAddendumLabel()}
                          />
                        </div>
                      )} */}

                    {shouldShowEmployees && (
                      <div className="col-sm-3 mt-1">
                        <SearchSelect
                          value={selectedEmployees}
                          onChange={(value) =>
                            this.handleSelectedEmployees(value)
                          }
                          options={this.presenter.setSelectedEmployee()}
                        />
                      </div>
                    )}
                    <div className="col-sm-3 mt-1">
                      <style>
                        {`
                          .custom-range-picker .ant-picker-input input::placeholder {
                            color: grey;
                            opacity: 1;
                          }
                        `}
                      </style>
                      <Space direction="vertical" size={20}>
                        <RangePicker
                          onChange={this.onChange.bind(this)}
                          className="custom-range-picker border p-2 fw-semibold"
                        />
                      </Space>
                    </div>
                    <div
                      className="col-sm-3 mt-1 d-flex align-items-center rounded"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <label
                        htmlFor="file-upload"
                        className="btn bg-white border border-primary text-primary "
                      >
                        <i className="bi bi-arrow-down-square" /> Import
                      </label>

                      <input
                        id="file-upload"
                        type="file"
                        accept=".csv"
                        onChange={this.handleFileUpload}
                        style={{ display: "none" }}
                      />
                      {this.state.filename && (
                        <span
                          className="ml-2 text-truncate"
                          style={{
                            maxWidth: "150px",
                            marginLeft: "5px",
                            cursor: "pointer",
                          }}
                          title={this.state.filename}
                        >
                          {this.state.filename}
                        </span>
                      )}
                    </div>
                    <div className="col-sm-3 mt-1">
                      <Button onClick={this.handleGenerate.bind(this)}>
                        <i Generate className="bi bi-list-task" /> Generate
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                selectable
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
                selected={selected}
                onSelect={(value) => this.presenter.onSelect(value)}
                onSelectAll={this.onSelectAll.bind(this)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.payrollListing && (
          <PayrollFormPage
            objects1={this.state.objects}
            closeAccess={this.closePrint.bind(this)}
            additionalSelectValue={this.state.additionalSelectValue}
            employmentType={this.state.employmentType}
            payrollCode={this.state.payrollCode}
            payrollType={payrollType}
            csvData={csvData}
            startDate={start}
            endDate={end}
            leaveType={leaveType}
            refetchData={this.refetchData.bind(this)}
            employeeID={selectedEmployeeID}
            selected={selected}
          />
        )}
      </>
    );
  }
}

export default GeneratePayrollPage;
